import 'babel-polyfill'
import axios from 'axios'
import Vue from 'vue'

import consignment from './components/consignment.vue'
import summary from './components/summary.vue'
import carrier from './components/carrier.vue'
import status from './components/status.vue'
import items from './components/items.vue'
import scans from './components/scans.vue'
import search from './components/search.vue'
import enquiry from './components/enquiry.vue'
import home from './components/home.vue'
import notification from './components/notification.vue'

import moment from 'moment'
import { VueSpinners } from '@saeris/vue-spinners'


import '../css/site.scss'
import '../css/efm.scss'
import '../css/oneflo.scss'
import '../css/bulk.scss'
import '../css/blank.scss'

Vue.config.productionTip = false

Vue.prototype.moment = moment
Vue.use(VueSpinners)
window.axios = axios
window.axios.defaults.headers.common['RequestVerificationToken'] = document.querySelector('input[name="__RequestVerificationToken"]').value;

Vue.component('bannerNotification', notification)
Vue.component('trackingConsignment', consignment)
Vue.component('trackingSummary', summary)
Vue.component('trackingCarrier', carrier)
Vue.component('trackingStatus', status)
Vue.component('trackingItems', items)
Vue.component('trackingScans', scans)
Vue.component('trackingSearch', search)
Vue.component('enquiryForm', enquiry)
Vue.component('trackingHome', home)

new Vue({
    el: '#app'
})